import React, { useEffect, useState } from "react";
import { View, FlatList, TouchableOpacity, TextInput } from "react-native";
import NSText from "./NSText";
import { Feather } from "@expo/vector-icons";

const GlobalMultiSelectSearchPicker = ({
  width,
  coords,
  data,
  selectedIndices,
  disabledItems,
  onItemPress,
  hideSearch = false,
}: {
  width: number;
  coords: { x: number; y: number };
  data: any[];
  selectedIndices?: string[];
  disabledItems?: string[];
  onItemPress: (value: any, index: number) => void;
  hideSearch?: boolean;
}) => {
  const [listData, setListData] = useState<any[]>(data);
  const [search, setSearch] = useState<string>("");

  console.log(selectedIndices);

  const shadowStyle = {
    marginBottom: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  };

  useEffect(() => {
    setListData(
      data?.filter((val) =>
        val?.toLowerCase?.()?.includes(search?.toLowerCase?.())
      )
    );
  }, [search]);

  return (
    <TouchableOpacity
      style={{
        position: "absolute",
        width,
        maxHeight: 300,
        top: coords.y,
        left: coords.x,
      }}
      activeOpacity={1}
    >
      {hideSearch ? null : (
        <TextInput
          style={{
            marginBottom: 2,
            paddingVertical: 7,
            paddingHorizontal: 15,
            fontFamily: "NotoSans",
            fontSize: 12,
            color: "#303030",
            borderRadius: 4,
            borderWidth: 1,
            borderColor: "#6300A3",
            backgroundColor: "white",
            ...shadowStyle,
            outline: "none",
          }}
          placeholder="Search"
          value={search}
          onChangeText={setSearch}
        />
      )}
      <View
        style={{
          flex: 1,
          borderRadius: 5,
          backgroundColor: "#F7F2FA",
          ...shadowStyle,
        }}
      >
        <FlatList
          showsVerticalScrollIndicator={false}
          data={listData}
          keyExtractor={(_, index) => index.toString()}
          renderItem={({ item, index }) => {
            return (
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  padding: 10,
                  backgroundColor: selectedIndices?.some(
                    (val) => val?.toLowerCase() === item?.toLowerCase()
                  )
                    ? "#6300A31A"
                    : "",
                  borderTopStartRadius: index === 0 ? 5 : 0,
                  borderTopEndRadius: index === 0 ? 5 : 0,
                  borderBottomStartRadius:
                    index === listData?.length - 1 ? 5 : 0,
                  borderBottomEndRadius: index === listData?.length - 1 ? 5 : 0,
                  alignItems: "center",
                  elevation: 5,
                  opacity: disabledItems?.includes(item) ? 0.4 : 1,
                }}
                disabled={disabledItems?.includes(item)}
                onPress={() => {
                  onItemPress(
                    item,
                    data?.findIndex((val) => val === item)
                  );
                }}
              >
                <View
                  style={{
                    width: 16,
                    height: 16,
                    borderWidth: 2,
                    borderRadius: 2,
                    borderColor: selectedIndices?.some(
                      (val) => val?.toLowerCase() === item?.toLowerCase()
                    )
                      ? "#6300A3"
                      : "#7D7D7D",
                    backgroundColor: selectedIndices?.some(
                      (val) => val?.toLowerCase() === item?.toLowerCase()
                    )
                      ? "#6300A3"
                      : "",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {selectedIndices?.some(
                    (val) => val?.toLowerCase() === item?.toLowerCase()
                  ) ? (
                    <Feather name="check" size={12} color="white" />
                  ) : null}
                </View>
                <NSText
                  style={{
                    maxWidth: "90%",
                    flexShrink: 1,
                    marginStart: 10,
                    fontSize: 12,
                    color: selectedIndices?.some(
                      (val) => val?.toLowerCase() === item?.toLowerCase()
                    )
                      ? "#303030"
                      : "#7D7D7D",
                  }}
                  text={item}
                />
              </TouchableOpacity>
            );
          }}
        />
      </View>
    </TouchableOpacity>
  );
};

export default GlobalMultiSelectSearchPicker;
